// password-please — the privacy policy, as markup.
//
// MOVED HERE ON 19 SEP 2026 out of `public/privacy.html`, which was deleted — the
// nodejavascript.com site standard (parts 1b and 4) requires the policy to be a section
// of the page rather than a page of its own. The text is unchanged; only the outer
// document (its <head>, its header and its footer) was dropped, and the policy's own
// <h1> became an <h2> so the page keeps exactly one <h1>.
//
// Generated from the deleted page — edit the words here from now on.
const policyHtml = `<h2>Privacy policy</h2>
        <p class="lede">
          This covers one site: <b>password-please.nodejavascript.com</b>, a free password generator
          run by <a href="https://nodejavascript.com/">nodejavascript.com</a>.
        </p>

        <h2>What happens to what you type</h2>
        <p>
          Nothing you do here leaves your browser. The passwords are made on your own machine, in the
          page, and the only thing that happens to one is that it is copied to your clipboard when you
          press copy. There is no account, no sign-in and no place to save anything — this site is a
          set of static files with no server behind it, so there is nothing to send a password to and
          no record of one anywhere.
        </p>

        <h2 id="cookies">Cookies, and the one thing that could set them</h2>
        <p>
          Google Analytics is the only cookie this site would ever set, and it is shut off until you
          use this site's own answer to it. The page loads nothing from Google until then: no script,
          no cookie, no request.
        </p>
        <div class="panel">
          <p>
            <b>Saying no is a real answer.</b> It is remembered in your browser's local storage rather
            than in a cookie, the question is not asked again on your next visit, and the page still
            works exactly as it did before.
          </p>
          <p>
            <b>You can change your answer at any time</b> — open the generator and press
            <b>Cookie settings</b> in its footer, which brings the question back without losing your
            place.
          </p>
        </div>
        <p>
          This page carries the same switch as the generator, so a visit here is counted only if you
          have already said yes on this site. If you have never answered, coming straight to this
          page sends nothing to Google at all.
        </p>

        <h2>What is measured when you say yes</h2>
        <ul>
          <li>Which pages are opened, and which buttons and links are pressed.</li>
          <li>How far down a page you read.</li>
          <li>
            What Google works out from the request itself: an approximate location from your address,
            and your browser, operating system and device type.
          </li>
        </ul>
        <p>
          <b>Never</b> what you type into the page, and never a password you generate — there is no
          field here whose contents are sent anywhere, consented or not.
        </p>

        <h2>Where it goes, and how long it is kept</h2>
        <p>
          The measurements go to Google Analytics, which processes them on our behalf in the United
          States. They are kept for fourteen months and then deleted. Nothing is sold, and nothing is
          shared with anyone else. We run no advertising and no trackers beyond that one.
        </p>

        <h2 id="contact">Contact</h2>
        <p>
          Questions, or a request to see or delete anything held about you, go through the
          <a href="https://nodejavascript.com/#contact">nodejavascript.com contact form</a>.
          This site is governed by the laws of Ontario, Canada.
        </p>

        <p class="muted">Last changed: 19 September 2026.</p>`

export default policyHtml
